/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_TryInputs */

const en_gc_home_try = /** @type {(inputs: Gc_Home_TryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try it in your browser`)
};

const zh_gc_home_try = /** @type {(inputs: Gc_Home_TryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器内试用`)
};

/**
* | output |
* | --- |
* | "Try it in your browser" |
*
* @param {Gc_Home_TryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_try = /** @type {((inputs?: Gc_Home_TryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_TryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_try(inputs)
	return zh_gc_home_try(inputs)
});
export { gc_home_try as "gc.home.try" }